/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SubscriptionTier {
    Connect = 'connect',
    Ops = 'ops',
    Respond = 'respond'
}


export function instanceOfSubscriptionTier(value: any): boolean {
    for (const key in SubscriptionTier) {
        if (Object.prototype.hasOwnProperty.call(SubscriptionTier, key)) {
            if (SubscriptionTier[key as keyof typeof SubscriptionTier] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubscriptionTierFromJSON(json: any): SubscriptionTier {
    return SubscriptionTierFromJSONTyped(json, false);
}

export function SubscriptionTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionTier {
    return json as SubscriptionTier;
}

export function SubscriptionTierToJSON(value?: SubscriptionTier | null): any {
    return value as any;
}

export function SubscriptionTierToJSONTyped(value: any, ignoreDiscriminator: boolean): SubscriptionTier {
    return value as SubscriptionTier;
}

